<template>
    <div v-show="visible" class="package-tooltip" @mouseenter="keepVisible" @mouseleave="hide">
        <PackageStatusCard :fullScreen="true" />


    </div>
</template>

<script>
import PackageStatusCard from "@/components/PackageStatusCard.vue";

export default {
    components: { PackageStatusCard },

    name: "PackageCardTooltip",
    props: {
        visible: { type: Boolean, default: false },

    },
    emits: ["hide", "keep-visible", "upgrade"],

    methods: {
        hide() {
            this.$emit("hide");
        },
        keepVisible() {
            this.$emit("keep-visible");
        },
        onUpgrade() {
            this.$emit("upgrade");
        },
    },
};
</script>

<style scoped>
/* === Animation === */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-5px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* === Tooltip Container === */
.package-tooltip {
    position: absolute;
    top: 100%;
    right: 0;
    width: 18rem;
    margin-top: 0.5rem;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 1rem;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    padding: 1rem;
    z-index: 50;
    animation: fadeIn 0.25s ease;
    transition: opacity 0.25s ease, transform 0.25s ease;
}
</style>